import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
    overflow: "hidden",
    padding: "2rem",
    background: "linear-gradient(180deg, #00351A 0%, #1B1B1B 100%)",
    minHeight: "100vh",
    "@media (max-width: 500px)": {
      padding: "0.5rem",
    },
  },
  container: {
    padding: "39px",
    borderRadius: "16px",
    backgroundColor: "#00351A",
    "@media (max-width: 650px)": {
      padding: "20px",
    },
  },
  margincont: {
    backgroundColor: "#001E0F",
    padding: "39px",
    borderRadius: "16px",
    "@media (max-width: 600px)": {
      padding: "1rem",
    },
  },
  content: {
    maxWidth: "900px",
    margin: "auto",
    color: "#FFF",
  },
  title: {
    fontSize: "32px",
    fontWeight: 700,
    textAlign: "center",
    marginBlock: "0px 10px",
    color: "#FFF",
    "@media (max-width: 600px)": {
      fontSize: "24px",
    },
  },
  lastUpdate: {
    fontSize: "14px",
    textAlign: "center",
    marginBlock: "0px 30px",
    color: "#CCC",
    "@media (max-width: 600px)": {
      fontSize: "12px",
    },
  },
  section: {
    marginBottom: "30px",
    "@media (max-width: 600px)": {
      marginBottom: "24px",
    },
  },
  heading: {
    fontSize: "24px",
    fontWeight: 700,
    marginBlock: "0px 16px",
    color: "#FFF",
    "@media (max-width: 600px)": {
      fontSize: "20px",
    },
  },
  intro: {
    fontSize: "16px",
    lineHeight: "160%",
    marginBlock: "0px",
    color: "#FFF",
    "@media (max-width: 600px)": {
      fontSize: "14px",
    },
  },
  text: {
    fontSize: "16px",
    lineHeight: "160%",
    marginBlock: "0px 12px",
    color: "#FFF",
    "@media (max-width: 600px)": {
      fontSize: "14px",
    },
  },
  list: {
    fontSize: "16px",
    lineHeight: "180%",
    marginBlock: "0px",
    paddingLeft: "24px",
    color: "#FFF",
    "& li": {
      marginBottom: "12px",
      "@media (max-width: 600px)": {
        fontSize: "14px",
        marginBottom: "10px",
      },
    },
    "& strong": {
      fontWeight: 600,
    },
  },
  note: {
    fontSize: "16px",
    lineHeight: "160%",
    marginBlock: "16px 0px",
    color: "#FFF",
    fontStyle: "italic",
    "@media (max-width: 600px)": {
      fontSize: "14px",
    },
  },
  consent: {
    fontSize: "16px",
    lineHeight: "180%",
    marginBlock: "0px 16px",
    color: "#FFF",
    "@media (max-width: 600px)": {
      fontSize: "14px",
    },
  },
}));

export default useStyles;
